import Pqp from "../../../3x1010/Pqp.js";
import Bout from "../../bout/Bout.js";
import Game from "../../Game.js";
import MazeConst from "../MazeConst.js";
import Styler from "./Styler.js";

export default class Featurer {
	constructor(handler, cfg) {
		this.handler = handler;
		this.gameLevel = -1;
		this.levelCol = -1;
		this.levelRow = -1;
		this.cfg = cfg;
	}

	init(dungeon = 0, gameLevel = -1, levelRow = -1, levelCol = -1) {
		this.dungeon = dungeon;
		this.gameLevel = gameLevel;
		this.levelRow = levelRow;
		this.levelCol = levelCol;
		//this.cfg = null;
		//this.levelRow = 27; //
		//this.levelCol = 27; //

	}

	getNextLevel(lRebuild = false) {
		if (!lRebuild) {
			this.gameLevel++;
		}


		let lFov;
		let dims;
		let rooms;
		let secrets;

		//this.gameLevel =4;


		if (this.cfg === null) {
			//console.log(this.gameLevel)
			lFov = this.incLevelOrApplyFov(lRebuild);
			dims = this.getMazeDimensions();
			rooms = this.getRooms(dims);
			//console.log(rooms)
			this.setRoomsType(rooms);
			secrets = this.getSecretRooms(rooms);
			this.styler = new Styler();
			this.styler.setStyle();
		} else {
			let det = this.getLevelDetails(this.dungeon, this.gameLevel);
			//console.log(det)
			lFov = det.fov === "true" ? true : false;
			dims = this.getMazeDimensionsFromCfg(det);

			/*dims = {
				"type": "square",
				"rows": "127",
				"cols": "127"
			}*/

			rooms = this.setRoomsFromCfg(det)
			secrets = parseInt(det.roomSecrets)
			this.styler = new Styler();

			let styles = det.style.split(",")
			this.styler.setStyle(parseInt(styles[Pqp.rnd(styles.length - 1)]));

		}

		//lFov = true; //
		//Game.DEBUG_NO_COLLISION = true; //
		//console.log(rooms);
		if (!Game.PROD) {
			console.log(" ")
			console.log("-= MAZE LEVEL " + this.gameLevel + " =-")
			console.log("Type: " + dims.type);
			console.log("Fov: " + lFov);
			console.log("Rows: " + dims.rows);
			console.log("Cols: " + dims.cols);
			console.log("Rooms: " + rooms.length + " (" + this.toStringSizes(rooms) + ")");
			console.log("Types: " + this.toStringTypes(rooms));
			console.log("Secret: " + secrets);
			console.log(this.styler)
		}
		

		/*
		rooms = [{
			"size": 0,
			"w": 2,
			"h": 2,
			"type": "typeOneExit",
		}
			/*, {
			"size": 0,
			"w": 2,
			"h": 2,
			"type": "typeOneExit",
			}*/
		/*	]
			secrets = 0;*/
		//rooms = [];
		//secrets = 0;
		//lFov = false;
		//console.log(rooms)
		let initer = {
			fov: lFov,
			secretRooms: secrets,
			rows: dims.rows,
			cols: dims.cols,
			rooms: rooms, //[
			//{ size: MazeConst.ROOM_SIZE_SMALL, type: MazeConst.ROOM_TYPE_ONE_EXIT },
			/*{ size: MazeConst.ROOM_SIZE_SMALL, type: MazeConst.ROOM_TYPE_TWO_EXIT },
			{ size: MazeConst.ROOM_SIZE_SMALL, type: MazeConst.ROOM_TYPE_HALLWAY },
			{ size: MazeConst.ROOM_SIZE_MEDIUM, type: MazeConst.ROOM_TYPE_HALLWAY },
			{ size: MazeConst.ROOM_SIZE_MEDIUM, type: MazeConst.ROOM_TYPE_ONE_EXIT },
			{ size: MazeConst.ROOM_SIZE_MEDIUM, type: MazeConst.ROOM_TYPE_TWO_EXIT },
			{ size: MazeConst.ROOM_SIZE_LARGE, type: MazeConst.ROOM_TYPE_TWO_EXIT },
			{ size: MazeConst.ROOM_SIZE_LARGE, type: MazeConst.ROOM_TYPE_ONE_EXIT },
			{ size: MazeConst.ROOM_SIZE_LARGE, type: MazeConst.ROOM_TYPE_HALLWAY }*/
			//],
			styler: this.styler,
			eventsHandler: this.handler
		}

		return initer;
	}

	incLevelOrApplyFov(lRebuild = false) {
		let lFov = false;
		let lIncLevel = false;
		let prob = (100 - (100 - this.gameLevel)) / 100

		let fovProb = 0.25 + prob;

		if (Pqp.check(fovProb)) {
			lFov = true;
		} else {
			lIncLevel = true;
		}

		if (lFov) {
			if (Pqp.check(0.25)) {
				lIncLevel = true;
			}
		}

		if (lRebuild) {
			lIncLevel = false;
		}

		if (lIncLevel) {
			if (this.levelCol === this.levelRow) {
				this.levelCol++;
			} else if (this.levelRow < this.levelCol) {
				this.levelRow++;
			} else {
				this.levelCol++
			}
		}
		return lFov;
	}


	getMazeDimensions() {
		let w = this.levelCol + Featurer.START_COLS;
		let h = this.levelRow + Featurer.START_ROWS;
		let type = "small";
		if (w * 2 > Game.AREA_GAME_COLS + Game.AREA_GAME_COLS / 5) {
			if (!Pqp.check(Featurer.PROB_SHAPE_SQUARE)) {
				if (Pqp.check(Featurer.PROB_SHAPE_RECT_H)) {
					type = "rect hori.";
					let span = Math.floor(h - Game.AREA_GAME_ROWS / 2) - 1;
					if (span > 2) {
						span = Pqp.rnd(span, 2);
					}
					w += span;
					h -= span;
				} else {
					type = "rect vert.";
					let span = Math.floor(w - Game.AREA_GAME_COLS / 2) - 1;
					if (span > 2) {
						span = Pqp.rnd(span, 2);
					}
					w -= span;
					h += span;

				}
			} else {
				//console.log("SQUARE")
				type = "square";
			}
		}

		//console.log(h, w);

		return { type: type, rows: h, cols: w };

	}

	getMazeDimensionsFromCfg(det) {
		let w = parseInt(det.cols);
		let h = parseInt(det.rows);
		let type = "small";
		let cmp = w * 2;
		if (h > w) {
			cmp = h * 2;
		}
		if (cmp > Game.AREA_GAME_COLS + Game.AREA_GAME_COLS / 5) {
			let shape = det.shape.split(",");
			shape = shape[Pqp.rnd(shape.length - 1)];
			if (shape === "h") {
				type = "rect hori.";
			} else if (shape === "v") {
				type = "rect vert.";
			} else {
				type = "square";
			}
		}

		//type = "rect hori."
		if (type != "small") {
			if (type == "rect hori.") {
				let span = Math.floor(h - Game.AREA_GAME_ROWS / 2) - 1;
				if (span > 2) {
					span = Pqp.rnd(span, 2);
				}
				w += span;
				h -= span;
			}
			if (type == "rect vert.") {
				let span = Math.floor(w - Game.AREA_GAME_COLS / 2) - 1;
				if (span > 2) {
					span = Pqp.rnd(span, 2);
				}
				w -= span;
				h += span;
			}
		}


		//let type = "small";
		/*if (w * 2 > Game.AREA_GAME_COLS + Game.AREA_GAME_COLS / 5) {
			if (!Pqp.check(Featurer.PROB_SHAPE_SQUARE)) {
				if (Pqp.check(Featurer.PROB_SHAPE_RECT_H)) {
					type = "rect hori.";
					let span = Math.floor(h - Game.AREA_GAME_ROWS / 2) - 1;
					if (span > 2) {
						span = Pqp.rnd(span, 2);
					}
					w += span;
					h -= span;
				} else {
					type = "rect vert.";
					let span = Math.floor(w - Game.AREA_GAME_COLS / 2) - 1;
					if (span > 2) {
						span = Pqp.rnd(span, 2);
					}
					w -= span;
					h += span;
				}
			} else {
				//console.log("SQUARE")
				type = "square";
			}
		}*/












		return { type: type, rows: h, cols: w };
	}


	getRooms(dims) {
		let ret = new Array();
		let area = (dims.rows * 2 + 1) * (dims.cols * 2 + 1);

		//console.log("--->" + area);
		// In base all'area determina le celle deputate a stanze
		let forRooms = Math.floor(area * Featurer.PERCENT_AREA_FOR_ROOMS);
		//console.log(forRooms)

		let lCondExit = false;
		let fuse = 0;
		let size = -1;
		while (!lCondExit) {
			size++;
			if (size === Featurer.PROB_ROOMS.length) {
				size = 0;
			}
			let prob = Featurer.PROB_ROOMS[size];
			let lInc = false;
			if (Pqp.check(prob)) {
				let room = this.getRoomBySize(size);
				let realArea = this.getRealArea(room);
				if (realArea < forRooms) {
					ret.push(room);
					forRooms -= realArea;
				} else {
					lInc = true;
				}
			}

			if (lInc) {
				fuse++;
			}
			if (fuse === 10) {
				lCondExit = true;
			}
		}

		if (ret.length > 2) {
			if (Pqp.check(Featurer.PROB_REMOVE_LARGER_ROOM)) {
				let max = 0;
				let index = 0;
				for (let x = 0; x < ret.length; x++) {
					let area = ret[x].w * ret[x].h;
					if (area > max) {
						max = area;
						index = x;
					}
				}
				ret.splice(index, 1);
			}
		}
		return ret;
	}


	getRoomBySize(size) {
		let a = Featurer.ROOMS_SIZES[size];
		let dims = a[Pqp.rnd(a.length - 1)];
		//dims = Pqp.shuffle(dims);
		let ret = { size: size, w: dims[0], h: dims[1], type: -1 }
		return ret;
	}

	getRealArea(room) {
		let w = room.w + room.w - 1;
		let h = room.h + room.h - 1;
		return w * h;
	}

	setRoomsType(rooms) {
		let types = new Array();
		let type = -1;
		let countHallways = 0;
		let howManySmall = 0;
		for (let x = 0; x < rooms.length; x++) {
			if (rooms[x].size == 0) {
				howManySmall++;
			}
		}

		for (let x = 0; x < rooms.length; x++) {
			let lCondExit = false;
			while (!lCondExit) {
				type++;
				if (type === Featurer.ROOMS_TYPES.length) {
					type = 0;
				}
				if (Pqp.check(Featurer.ROOMS_TYPES[type])) {
					let add = true;
					if (type === 2) {
						if (countHallways === rooms.length - howManySmall) {
							countHallways++;
							add = false;
						}
					}
					if (add) {
						types.push(type);
						lCondExit = true;
					}
				}
			}
		}
		types = Pqp.shuffle(types);

		// Assegna prima le hallway ai non small
		for (let x = 0; x < types.length; x++) {
			if (types[x] === 2) {
				for (let y = 0; y < rooms.length; y++) {
					if (rooms[y].size !== 0) {
						if (rooms[y].type === -1) {
							rooms[y].type = MazeConst.ROOM_TYPES[types[x]];
							break;
						}
					}
				}
			}
		}

		// Assegna il resto a caso
		for (let x = 0; x < types.length; x++) {
			if (types[x] !== 2) {
				for (let y = 0; y < rooms.length; y++) {
					if (rooms[y].type === -1) {
						rooms[y].type = MazeConst.ROOM_TYPES[types[x]];
						break;
					}
				}
			}
		}
	}

	setRoomsFromCfg(det) {
		let ret = new Array();
		let sizes = det.roomsSize.split(",")
		let types = det.roomsType.split(",")


		for (let x = 0; x < parseInt(det.rooms); x++) {
			let size = sizes[x];
			if (size === "s") {
				size = 0;
			} else if (size === "m") {
				size = 1;
			} else if (size === "l") {
				size = 2;
			} else if (size === "h") {
				size = 3;
			}
			//console.log(size)
			let o = this.getRoomBySize(size);

			let type = types[x];
						//console.log("----->"+type)
			if (type === "1") {
				type = "typeOneExit";
			} else if (type === "2") {
				type = "typeTwoExit";
			} else if (type === "h") {
				type = "typeHallway";
			}
			o.type = type;

			/*let o = {
				h: 4,
				size: size,
				type: "typeHallway",
				w: 4
			}*/
			ret.push(o)
		}

		return ret;
	}


	toStringSizes(rooms) {
		let ret = ""
		for (let x = 0; x < rooms.length; x++) {
			let c = ""
			if (rooms[x].size === 0) {
				c = "s"
			}
			if (rooms[x].size === 1) {
				c = "m"
			}
			if (rooms[x].size === 2) {
				c = "l"
			}
			if (rooms[x].size === 3) {
				c = "h"
			}
			ret += c + ", ";
		}
		ret = ret.substr(0, ret.length - 2);
		return ret;

	}
	toStringTypes(rooms) {
		let ret = ""
		for (let x = 0; x < rooms.length; x++) {
			let c = ""
			if (rooms[x].type === MazeConst.ROOM_TYPE_HALLWAY) {
				c = "h"
			}
			if (rooms[x].type === MazeConst.ROOM_TYPE_ONE_EXIT) {
				c = "1"
			}
			if (rooms[x].type === MazeConst.ROOM_TYPE_TWO_EXIT) {
				c = "2"
			}
			ret += c + ", ";
		}
		ret = ret.substr(0, ret.length - 2);
		return ret;

	}


	getSecretRooms(rooms) {
		let secret = 0;
		let hallways = 0;
		for (let x = 0; x < rooms.length; x++) {
			if (rooms[x].type === MazeConst.ROOM_TYPE_HALLWAY) {
				hallways++;
			}
		}
		for (let x = 0; x < rooms.length; x++) {
			if (rooms[x].type !== MazeConst.ROOM_TYPE_HALLWAY) {
				if (secret < Featurer.PROB_SECRET_ROOM.length) {
					if (Pqp.check(Featurer.PROB_SECRET_ROOM[secret])) {
						secret++;
					}
				} else {
					if (Pqp.check(Featurer.PROB_SECRET_ROOM[Featurer.PROB_SECRET_ROOM.length - 1])) {
						secret++;
					}
				}
			}
		}
		if (secret > Math.floor(rooms.length / 2)) {
			secret = Math.floor(rooms.length / 2);
		}

		return secret;
	}

	getLevelDetails(dungeon, level) {
		//console.log(dungeon,level)
		for (let x = 0; x < this.cfg.length; x++) {
			if (parseInt(this.cfg[x].idMaze) === dungeon) {
				if (parseInt(this.cfg[x].level) === level) {
					return this.cfg[x];
				}
			}
		}
	}

	getCurrentLevelDetails() {
		return this.getLevelDetails(this.dungeon, this.gameLevel);
	}

}

Featurer.START_COLS = 3;
Featurer.START_ROWS = 3;
Featurer.PERCENT_AREA_FOR_ROOMS = 1 / 5;


Featurer.PROB_SHAPE_SQUARE = 0.5;
Featurer.PROB_SHAPE_RECT_H = 0.5;

Featurer.PROB_ROOMS = [
	0.7, // small
	0.6, // medium
	0.5, // large
	0.4  // huge
]

Featurer.ROOMS_SIZES = [
	[[2, 2], [3, 2]],
	[[3, 3], [4, 2]],
	[[4, 3], [4, 4]],
	[[5, 3], [5, 4], [5, 5]]
]

Featurer.PROB_REMOVE_LARGER_ROOM = 0.5;

Featurer.ROOMS_TYPES = [
	0.7,
	0.6,
	0.4
]

Featurer.PROB_SECRET_ROOM = [
	0.5,
	0.4,
	0.3,
	0.2,
	0.1
]




